// @flow
import { configValue } from 'utils/config';

const allowRedirect = (url: string) => {
  const corsOrigins = configValue('idealist', 'corsOrigins');
  if (url.startsWith('/')) {
    return true;
  }
  if (!corsOrigins) {
    return false;
  }
  const allowedDomains = corsOrigins.split(',');
  if (allowedDomains === ['*']) {
    return true;
  }
  // remove path and query params
  const host = url
    .split('/')
    .slice(0, 3)
    .join('/')
    .split('?')[0];
  return allowedDomains.includes(host);
};

export default allowRedirect;
